<ng-container *ngTemplateOutlet="offCanvas"></ng-container>
<ng-template #offCanvas let-offcanvas>
	<div [ngClass]="{'hidden': !displayOffcanvas}">
		<div class="offcanvas-header">
			<h4 class="offcanvas-title" id="offcanvas-basic-title"> {{ title }}</h4>
			<button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
		</div>
		<div class="offcanvas-body">
			<form>
				<div class="mb-3">
					<!-- Template from parent goes here-->
					<ng-container [ngTemplateOutlet]="offcanvasBody"></ng-container>
				</div>
			</form>
		</div>
	</div>
</ng-template>